(function ($) {
    function rememberDisplay($el, node) {
        if ($el.data('__hasDisplaySnapshot')) return;
        $el.data('__inlineDisplay', node.style.display || '');
        $el.data('__computedDisplay', window.getComputedStyle(node).display);
        $el.data('__hasDisplaySnapshot', true);
    }

    $.fn.customHide = function (callback) {
        return this.each(function () {
            const $el = $(this);

            if ($el.css('display') !== 'none') {
                rememberDisplay($el, this);
            }

            $el.css('display', 'none');

            // If a callback is passed and is a function, call it
            if (typeof callback === 'function') {
                callback.call(this); // `this` = the element being hidden
            }
        });
    };

    $.fn.customShow = function () {
        return this.each(function () {
            const $el = $(this);
            $el.removeClass('hide');

            const inline = $el.data('__inlineDisplay');
            const computed = $el.data('__computedDisplay');

            const target =
                (inline && inline !== 'none') ? inline :
                    (computed && computed !== 'none') ? computed : '';

            $el.css('display', target);

            // Clear snapshot; next hide will re-measure in case styles changed
            $el.removeData('__inlineDisplay')
                .removeData('__computedDisplay')
                .removeData('__hasDisplaySnapshot');
        });
    };

    $.fn.customToggle = function (state) {
        return this.each(function () {
            const $el = $(this);
            const show = (typeof state === 'boolean') ? state : ($el.css('display') === 'none');
            if (show) {
                $el.customShow();
            } else {
                // Capture before hiding if currently shown
                if ($el.css('display') !== 'none') {
                    rememberDisplay($el, this);
                }
                $el.css('display', 'none');
            }
        });
    };
})(jQuery);
